import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase/app';
import 'firebase/auth';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/service/auth.service';
import { ClinicService } from 'src/app/service/clinic.service';
import { FirestoreService } from 'src/app/service/firestore.service';
import { FirebaseCollection } from 'src/app/_enums/firebaseCollection.enum';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  phoneNumber: any;
  email: string;
  userData = {};
  password: string;
  displayDialog: boolean;
  recaptchaVerifier: firebase.auth.RecaptchaVerifier;
  confirmResult: firebase.auth.ConfirmationResult;
  code: string;
  phoneRegax: RegExp =
    /^[+]{1}[1]{1}[\s]*((\([0-9]{3}\))|[0-9]{3})[\s\-]?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[0-9]{4}$/;
  constructor(
    private authService: AuthService,
    private firestoreService: FirestoreService,
    private messageService: MessageService,
    private _router: Router,
    private _clinicService: ClinicService
  ) {}

  ngOnInit(): void {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      'recaptcha-container'
    );
  }

  /// tslint:disable-next-line: typedef
  signIn(): void {
    try{

    }catch(e){
      console.log(e);
    }
    if (this.email) {
      this.firestoreService
        .getStaffWithQuery(['email', '==', this.email])
        .then(async (querySnapshot: any) => {
          let userExist = false;
          querySnapshot.forEach((docu) => {
            userExist = docu.id ? true : false;
            localStorage.setItem('name', `${docu.data().fullName}`);
            localStorage.setItem('role', `${docu.data().role}`);
          });
          // localStorage.setItem( 'timeZone', (
          //     (await await this._clinicService
          //       .get(FirebaseCollection.OPERATING_HOUR)
          //       .toPromise()) as any
          //   ).timezoneName
          // );
          if (userExist) {
            this.authService.doLogin(this.email, this.password);
          } else {
            this.messageService.add({
              key: 'info',
              severity: 'error',
              summary: 'Access Denied',
              detail: `You are not Registered.  Please contact your admin`,
            });
          }
        });
    } else {
      if (this.phoneNumber) {
        // console.log('queryNumber', queryNumber);
        this.firestoreService
          .getStaffWithQuery(['phone', '==', this.phoneNumber])
          .then((querySnapshot: any) => {
            let userExist = false;
            querySnapshot.forEach((docu) => {
              userExist = docu.id ? true : false;
              localStorage.setItem('name', `${docu.data().fullName}`);
              localStorage.setItem('role', `${docu.data().role}`);
            });
            if (userExist) {
              const appVerifier = this.recaptchaVerifier;
              const phoneNumberString = this.phoneNumber;
              const self = this;
              firebase
                .auth()
                .signInWithPhoneNumber(phoneNumberString, appVerifier)
                .then((confirmationResult) => {
                  this.displayDialog = true;
                  this.confirmResult = confirmationResult;
                })
                .catch((error) => {
                  self.messageService.add({
                    key: 'info',
                    severity: 'error',
                    summary: 'Error',
                    detail: `SMS not sent: ${error}`,
                  });
                });
            } else {
              this.messageService.add({
                key: 'info',
                severity: 'error',
                summary: 'Accress Denied',
                detail: `You are not Registered with our App.  Please contact your admin`,
              });
            }
          });
      } else {
        this.messageService.add({
          key: 'info',
          severity: 'error',
          summary: 'Incorrect Phone Format',
          detail: `Please input phone number in standard format and with country code`,
        });
      }
    }
  }

  verifyCode(): void {
    this.authService.doPhoneVerify(
      this.confirmResult.verificationId,
      this.code
    );
  }
}
